import { render } from "./AdminPending25Liquidations.vue?vue&type=template&id=2e2cb273"
import script from "./AdminPending25Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminPending25Liquidations.vue?vue&type=script&lang=js"

import "./AdminPending25Liquidations.vue?vue&type=style&index=0&id=2e2cb273&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__